import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.875 5.833l-.881.882 2.862 2.868H3.75v1.25h10.106l-2.868 2.87.887.88 4.375-4.375-4.375-4.375z" fill="#54585D" /></svg>);